import ReportCard from '@/components/ReportCard';
import TotalsCard from '@/pages/Attribution/Components/Cards/TotalsCard';
import Filters from '@/pages/Attribution/Components/Filters/OfflineSales';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { selectOfflineSalesFilters } from '@/store/selectors/attribution/offlineSales.selectors';
import { getOfflineSalesData, resetOfflineSalesPageState } from '@/store/slices/attribution/offlineSales.slice';
import { useEffect } from 'react';
import SalesFunnelCard from './Components/Cards/SalesFunnelCard';

const OfflineSalesTab = () => {
  const dispatch = useAppDispatch();
  const filters = useAppSelector(selectOfflineSalesFilters);

  useEffect(() => {
    if (!filters.advertiserId) {
      return;
    }

    dispatch(getOfflineSalesData());
  }, [filters, dispatch]);

  useEffect(() => {
    return () => {
      dispatch(resetOfflineSalesPageState());
    };
  }, [dispatch]);

  return (
    <>
      <Filters />
      {filters.advertiserId ? (
        <>
          <ReportCard className='col-span-4'>
            <SalesFunnelCard />
          </ReportCard>
          <TotalsCard />
        </>
      ) : (
        <p>Please select advertiser</p>
      )}
    </>
  );
};

export default OfflineSalesTab;
